module.exports = [{
      plugin: require('../../../node_modules/.pnpm/gatsby-plugin-layout@1.3.1/node_modules/gatsby-plugin-layout/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../../../node_modules/.pnpm/gatsby-plugin-mdx@1.2.7_@mdx-js+mdx@1.6.22_@mdx-js+react@1.6.1/node_modules/gatsby-plugin-mdx/gatsby-browser.js'),
      options: {"plugins":[],"extensions":[".md",".mdx"],"rehypePlugins":[null,null]},
    }]
